import { injectable } from 'inversify';
import { folder, folder_all, folder_dto } from '@Api';
import { EntityVersioning, Folder, Nullable } from '@Models';
import { IMapper } from '../IMapper';

@injectable()
export class FolderMapper implements IMapper<string, folder, folder, Folder> {
  public map(item: folder_all): Folder {
    return {
      id: item.id,
      name: item.name,
      isShare: false,
      parentId: null,
    } satisfies Folder as Folder;
  }

  public mapFull(item: folder): Folder {
    return {
      id: item.id,
      name: item.name,
      isShare: item.is_share,
      parentId: item.parent_id,
    } satisfies Folder as Folder;
  }

  public mapDto(item: Folder): folder_dto {
    return {
      id: item.id,
      name: item.name,
      is_share: item.isShare,
      parent_id: item.parentId,
    } satisfies folder_dto as folder_dto;
  }

  mapVersioning(data: any): Nullable<EntityVersioning<string>> {
    return null;
  }
}
